module.exports = __webpack_public_path__ + "media/images/icons/mobile-8cd482eb8c1622be9e5ca0056004cd48.svg";